export default __webpack_public_path__ + "static/media/ic_switzerland.49cba500.svg";